import * as types from "./types";

export default {
  [types.SET_SUBSCRIPTIONOBJECT](state, payload) {
    state.currentSubscriptionObject = payload;
  },
  [types.SET_SUBSCRIPTIONPLANLIST](state, payload) {
    state.subscriptionplanList = payload;
  }
};
